/**
 * Days after creation before uploads and generations are deleted by the storage
 * cleanup process. Keep in step with that process; all user-facing copy reads it.
 */
export const RETENTION_DAYS = 14;

const DAY_MS = 24 * 60 * 60 * 1000;

/** True once a run's files are past retention and have been deleted (applies to every user, VIPs included). */
export function isExpired(createdAt: string, now = Date.now()) {
  return now - new Date(createdAt).getTime() > RETENTION_DAYS * DAY_MS;
}

/**
 * True for a finished run whose files the clean-up has deleted. Failed and
 * pending runs never stored anything, so they keep showing as they are.
 */
export function hasExpiredFiles(run: { status: string; created_at: string }, now = Date.now()): boolean {
  return run.status === "completed" && isExpired(run.created_at, now);
}
